import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { filter, fromEvent, map, type Observable, share } from 'rxjs';

import type { IUserActivityProvider } from './i-user-activity.provider';

/**
 * Cosa succede sul documento, letto una volta sola per tutta l'applicazione. E' l'unico punto che ascolta
 * il DOM per conto del diario tecnico.
 */
@Injectable()
export class DocumentUserActivityProvider implements IUserActivityProvider {
  private readonly document = inject(DOCUMENT);

  /**
   * `visibilitychange` e non `beforeunload`: su mobile una scheda che passa in secondo piano puo' non
   * tornare mai, e `beforeunload` li' non arriva. `pagehide` copre il caso della navigazione via.
   */
  readonly pageHidden$: Observable<void> = fromEvent(this.document, 'visibilitychange').pipe(
    filter(() => this.document.visibilityState === 'hidden'),
    map(() => undefined),
    share(),
  );
}
